import { FC } from 'react';
import clsx from 'clsx';

import './SettingsPage.scss';
import { SettingsPageContent, SettingsSideBar } from '../../components';

interface SettingsPageProps {
  className?: string;
}

const SettingsPage: FC<SettingsPageProps> = ({ className }) => {
  return (
    <div className={clsx('settings-page', className)}>
      <SettingsSideBar className="settings-page__side-bar" />
      <SettingsPageContent className="settings-page__content" />
    </div>
  );
};

export default SettingsPage;
